import {inject, injectable} from "inversify";
import {LineupperInterface} from "@/modules/ai/interfaces";
import {Player, Team} from "@/modules/team/entity";
import {FormationEnum} from "@/modules/team/enums";
import chance from "@/modules/base/services/chance";
import {EventEmitter} from "@/modules/base/events";

@injectable()
export default abstract class AbstractLineupper implements LineupperInterface {
  constructor(
    @inject(EventEmitter) protected em: EventEmitter,
  ) {}

  async lineup(team: Team) {
    await team.players.forEachAsync(async (p: Player) => {
      if (p.lineup) {
        p.lineup = null;
        await p.save();
      }
    });

    team.formation = await this.formation();
    await team.save();
  }

  async formation(): Promise<FormationEnum> {
    return chance.randomEnum(FormationEnum);
  }
}
